module.exports = __webpack_public_path__ + "assets/img/step4-title.4022eb95.svg";